import React from 'react';
import { Navigate, Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";
//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { useAuthContext } from '../Components/AuthContext';
import { isSitePaused } from '../common/permissions';

export const hasRouteAccess = (route, userInfo) => {
  if (route.requiredHqAdmin) {
    return userInfo?.is_hq_admin === true;
  }

  if (route.requiredGlobalAdmin) {
    return Boolean(userInfo?.is_global_admin);
  }

  if (route.blockedWhenSitePaused && isSitePaused(userInfo)) {
    return false;
  }

  if (!route.requiredCapability) {
    return true;
  }

  if (userInfo?.is_global_admin) {
    return true;
  }

  const capabilities = Array.isArray(userInfo?.capabilities) ? userInfo.capabilities : [];
  return capabilities.includes(route.requiredCapability);
};

const Index = () => {
    const {userInfo, isLoading} = useAuthContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    
    return (
        <React.Fragment>
            <Routes>
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                <route.component />
                            </NonAuthLayout>
                        }
                        key={`public-${idx}`}
                    />
                ))}

                <Route path="/*" element={
                    <AuthProtected>
                        <VerticalLayout>
                            <Routes>
                                {authProtectedRoutes.map((route, idx) => (
                                    <Route
                                        path={route.path}
                                        element={(() => {
                                          if (!hasRouteAccess(route, userInfo)) {
                                            return <Navigate to="/dashboard-crm" replace />;
                                          }

                                          return <route.component />;
                                        })()}
                                        key={`auth-${idx}`}
                                    />
                                ))}
                            </Routes>
                        </VerticalLayout>
                    </AuthProtected>
                } />
            </Routes>
        </React.Fragment>
    );
};

export default Index;
